module.exports = __webpack_public_path__ + "static/media/change-password.b4efee89.svg";